// Generate Table of Contents (of h2 elements)

const tocWrapper = document.querySelector('.intro__table-of-contents');

if (tocWrapper) {
    const headings = tocWrapper.parentNode.parentNode.querySelectorAll('h2');

    if (headings) {
        let toc = '<nav><ul>';

        [...headings].forEach(h2 => {
            let id = makeSafeForCss(h2.innerHTML);
            h2.setAttribute('id', id);
            toc += "<li><a class='anchor-link' href='#" + id + "'>" + h2.innerHTML + '</a> ›</li>';
        });

        tocWrapper.innerHTML = toc + '</ul></nav>';
    }
}

function makeSafeForCss(string) {
    return string
        .toLowerCase()
        .replace(/ö/, 'oe')
        .replace(/ü/, 'ue')
        .replace(/ä/, 'ae')
        .replace(/ß/, 'ss')
        .replace(/(^-\d-|^\d|^-\d|^--)/, 'a$1')
        .replace(/[\W]/g, '-')
        .replace(/^-|-$/, '');
}
